import React, { Component } from "react";
import * as PropTypes from "prop-types";
import { Col, Form, Modal, Row, Switch } from "antd";

import moment from "moment";

import { permissionService, roleAndPermissionService } from "./../../redux/services";

import { UIDrawerForm, UIFormSection, UIPermissionGroups } from "./../../components";

class Show extends Component {
	static propTypes = {
		visible : PropTypes.bool.isRequired,
		onClose : PropTypes.func.isRequired,
		external: PropTypes.bool,
	};

	constructor(props) {
		super(props);

		this.state = {
			isLoading               : true,
			uuid                    : 0,
			item                    : {},
			permissions             : [],
			permissionsSelected     : [],
			permissionsCheckAll     : [],
			permissionsIndeterminate: [],
		};
	}

	onOpen = (uuid) => {
		this.setState({
			isLoading: true,
			uuid     : uuid,
			item     : {},
		});

		let item = {};

		roleAndPermissionService.show({uuid})
		.then((response) => {
			item = response.data.data;

			return permissionService.getAutocomplete({
				orderBy: "group:asc|order:asc"
			});
		})
		.then((response) => {
			let permissions = response.data.data;

			let newPermissionsSelected      = item.permissions.map(permission => permission.uuid);
			let newPermissionsCheckAll      = [];
			let newPermissionsIndeterminate = [];

			permissions.forEach(permissionGroup => {
				let groupTotal         = permissionGroup.permissions.length;
				let groupTotalSelected = 0;

				permissionGroup.permissions.forEach(permission => {
					let permissionIndex = newPermissionsSelected.indexOf(permission.uuid);

					if( permissionIndex !== -1 )
					{
						groupTotalSelected++;
					}
				});

				if( groupTotal === groupTotalSelected )
				{
					newPermissionsCheckAll.push(permissionGroup.key);
				}
				else if( groupTotalSelected > 0 )
				{
					newPermissionsIndeterminate.push(permissionGroup.key);
				}
			});

			this.setState({
				isLoading               : false,
				item                    : item,
				permissions             : permissions,
				permissionsSelected     : newPermissionsSelected,
				permissionsCheckAll     : newPermissionsCheckAll,
				permissionsIndeterminate: newPermissionsIndeterminate,
			});
		})
		.catch((data) => {
			Modal.error({
				title  : "Ocorreu um erro!",
				content: String(data),
				onOk   : () => {
					// Force close
					return this.onClose();
				}
			});
		});
	};

	resetFields = () => {
		this.setState({
			item                    : {},
			permissions             : [],
			permissionsSelected     : [],
			permissionsCheckAll     : [],
			permissionsIndeterminate: [],
		});
	};

	onClose = () => {
		// Reset fields
		this.resetFields();

		// Callback
		this.props.onClose();
	};

	render() {
		const {visible} = this.props;

		const {isLoading, item, permissions, permissionsSelected, permissionsCheckAll, permissionsIndeterminate} = this.state;

		return (
			<UIDrawerForm
				visible={visible}
				width={700}
				onClose={this.onClose}
				isLoading={isLoading}
				showBtnSave={false}
				icon={<i className="fal fa-lock" />}
				title="Visualizar papel"
				subtitle="Veja os detalhes do papel e todas as permissões configuradas no sistema.">
				<Form layout="vertical">
					<UIFormSection
						icon={<i className="fal fa-clipboard-list" />}
						title="Informações gerais">
						<Row gutter={16}>
							<Col xs={24} md={12}>
								<Form.Item label="Nome">
									{item.name ?? "-"}
								</Form.Item>
							</Col>
							<Col xs={24} md={12}>
								<Form.Item label="Descrição">
									{item.description ?? "-"}
								</Form.Item>
							</Col>
						</Row>
						<Row gutter={16}>
							<Col xs={24} sm={8}>
								<Form.Item label="Permissões">
									{item.permissions_count ?? "-"}
								</Form.Item>
							</Col>
							<Col xs={24} sm={8}>
								<Form.Item label="Usuários">
									{item.users_count ?? "-"}
								</Form.Item>
							</Col>
							<Col xs={24} sm={8}>
								<Form.Item label="Gestor">
									<Switch disabled checked={!!item.is_gestor} />
								</Form.Item>
							</Col>
						</Row>
						<Row gutter={16}>
							<Col xs={24} sm={12}>
								<Form.Item label="Criação">
									{item.created_at ? moment(item.created_at).calendar() : "-"}
								</Form.Item>
							</Col>
							<Col xs={24} sm={12}>
								<Form.Item label="Última atualização">
									{item.updated_at ? moment(item.updated_at).calendar() : "-"}
								</Form.Item>
							</Col>
						</Row>
					</UIFormSection>
					<UIPermissionGroups
						disabled
						groups={permissions}
						selected={permissionsSelected}
						checkedAll={permissionsCheckAll}
						indeterminate={permissionsIndeterminate}
					/>
				</Form>
			</UIDrawerForm>
		)
	}
}

export default Show;
